document.addEventListener("DOMContentLoaded", function () {
  var ratingElement = document.querySelector(".loox-rating-hp");

  var dataRaters = ratingElement.getAttribute("data-raters");
  var dataRating = ratingElement.getAttribute("data-rating");

  function generateReviewsSchema() {
    var reviewsSchema = {
      "@context": "https://schema.org",
      "@type": "Product",
      name: "Pedal Commander Throttle Response Controller",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: dataRating,
        reviewCount: dataRaters,
      },
    };

    return JSON.stringify(reviewsSchema);
  }

  function injectreviewsSchema() {
    var reviewsSchemaString = generateReviewsSchema();
    var script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = reviewsSchemaString;
    document.head.appendChild(script);
  }
  if (dataRaters || dataRating) {
    injectreviewsSchema();
  }
});
